import React, { ReactNode } from "react";
import { Button, IconButton, MenuItem, Typography } from "@mui/material";
import { MinusIcon } from "shared/icons/MinusIcon";
import { PlusIcon } from "shared/icons/PlusIcon";
import { KababMenu } from "../Menu/KababMenu";

export const ListOfInputs = (props: ListOfInputsProps) => {
  const { title, inputSections, onAddInput, addOptions } = props;

  return (
    <div className="module-list-of-inputs">
      <div className="_d-flex-ali-center-jc-sb-md-gap">
        <Typography variant="h4" color="text.secondary">
          {title}
        </Typography>

        {addOptions ? (
          <KababMenu
            icon={<PlusIcon />}
            closeOnClick
            items={addOptions.map((option) => (
              <MenuItem key={option.title} onClick={option.onClick}>
                {option.title}
              </MenuItem>
            ))}
          />
        ) : (
          <IconButton onClick={onAddInput}>
            <PlusIcon />
          </IconButton>
        )}
      </div>
      <div className="_d-grid-md-gap">
        {inputSections.map((inputSection, i) => {
          if (!inputSection.inputs.length) {
            return null;
          }

          return (
            <div key={i}>
              {inputSection.title && (
                <Typography variant="h4" color="text.tertiary" mb={3}>
                  {inputSection.title}
                </Typography>
              )}
              {inputSection.subTitle}
              {inputSection.inputs.map((input, j) => (
                <div key={j} className="input-container">
                  {input.inputElement}
                  <IconButton onClick={input.onDelete}>
                    <MinusIcon />
                  </IconButton>
                </div>
              ))}
              {inputSection.addAction && (
                <Button variant="text" onClick={inputSection.addAction.onClick} color="primary">
                  <PlusIcon />
                  {inputSection.addAction.title}
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export interface ListOfInputsProps {
  title: string;
  inputSections: ListOfInputsSection[];
  onAddInput?: () => void;
  addOptions?: AddOptions[];
}

export type ListOfInputsSection = {
  inputs: ListOfInputsInput[];
  title?: string;
  subTitle?: ReactNode;
  addAction?: {
    title: string;
    onClick: () => void;
  };
};

export type ListOfInputsInput = {
  inputElement: ReactNode;
  onDelete: () => void;
};

type AddOptions = {
  title: string;
  onClick: () => void;
};
